export class NullRenderer {
  domElement: HTMLCanvasElement

  constructor() {
    this.domElement = document.createElement('canvas')
  }

  render() {
    return void 0
  }
  setSize() {
    return void 0
  }
}
